import React from "react";
import { Stack, Card, CardHeader, Typography, CardMedia, Box } from "@mui/material";
import { useContext } from "react";
import { WidgetContext } from "../../store/widgetContext";
import { get } from "lodash";
import { trimString, formatDate } from "../../utils/common";
import { CiImageOn } from "react-icons/ci";
import { useWidgetMsg } from "../../hooks/widget/useWidgetMsg";

export default function HomeArticles({ onArticleClick }) {
	const { widget } = useContext(WidgetContext);
	const homeDocs = get(widget, "pages.home.docs", []);
	const { msg } = useWidgetMsg();

	if (!homeDocs || homeDocs.length === 0) {
		return null;
	}

	return (
		<Stack direction="column" spacing={1}>
			{homeDocs.map((el, idx) => {
				const doc = el.doc;
				return (
					<Card
						key={idx}
						sx={{
							maxHeight: "400px",
							borderRadius: "16px",
							display: "flex",
							flexDirection: "column",
							justifyContent: "flex-start",
							flexShrink: "0",
							cursor: "pointer",
						}}
						onClick={() => onArticleClick(doc)}
					>
						{doc.media ? (
							<CardMedia
								component="img"
								image={doc.media}
								alt="card image"
								sx={{ borderRadius: "16px", objectFit: "cover", height: "185px" }}
							/>
						) : (
							<Box
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									borderRadius: "16px",
									height: '185px',
									backgroundColor: '#f0f0f0',
								}}>
								<CiImageOn size={40} color="#aaa" />
							</Box>
						)}
						{doc?.title && (
							<CardHeader
								title={<Typography variant="body1">{trimString(doc.title, 25)}</Typography>}
								subheader={doc?.updatedAt ? formatDate(doc?.updatedAt, msg) : ""}
							/>
						)}
					</Card>
				);
			})}
		</Stack>
	);
}

